import Vue from 'vue';
import VueProgressBar from 'vue-progressbar';

const options = {
  color: '#5aab04',
  failedColor: '#e24a41',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
  // autoRevert: true,
  // location: 'left',
  // inverse: false,
};

Vue.use(VueProgressBar, options);



// WEBPACK FOOTER //
// ./src/plugins/vue-progress.js